import { useRef } from "react";
import { useIntl } from "react-intl";
import { Day0WelcomeSection } from "./Day0WelcomeSection";
import { Day0VideoSection } from "./Day0VideoSection";
import { Day0GetStartedSection } from "./Day0GetStartedSection";
// TODO: Bring back the Knowledge Center chat once knowledge center integration
// is available (see the commented <KnowledgeCenterChat /> in the render below).
// import { KnowledgeCenterChat } from "../KnowledgeCenterChat/KnowledgeCenterChat";
import "./Day0Landing.css";

/**
 * Day-0 (first-run) landing: two full-height scroll-snap screens — welcome hero
 * and get-started steps. This component only orchestrates the snap container and
 * section refs; each screen lives in its own file to keep them focused.
 */
export function Day0Landing() {
  const intl = useIntl();

  // Refs let the CTAs / chevrons glide to the next full-page section on click.
  const sectionRefs = useRef<Array<HTMLElement | null>>([]);
  const scrollToSection = (index: number) =>
    sectionRefs.current[index]?.scrollIntoView({ behavior: "smooth" });

  const scrollHintLabel = intl.formatMessage({
    id: "qFQeqL",
    defaultMessage: "Scroll to next section",
    description: "Accessible label for the onboarding scroll-down chevron",
  });

  return (
    <>
      {/* TODO: Re-enable the Knowledge Center chat once we have knowledge
          center integration. */}
      {/* <KnowledgeCenterChat /> */}
      <div className="Onboarding h-[calc(100dvh-4rem)] snap-y snap-mandatory scroll-smooth overflow-y-auto bg-[var(--color-page-bold,#ffffff)]">
        <Day0WelcomeSection
          sectionRef={(el) => (sectionRefs.current[0] = el)}
          onScrollToSteps={() => scrollToSection(2)}
          onScrollToVideo={() => scrollToSection(1)}
          scrollHintLabel={scrollHintLabel}
        />
        <Day0VideoSection
          sectionRef={(el) => (sectionRefs.current[1] = el)}
          onScrollToSteps={() => scrollToSection(2)}
          scrollHintLabel={scrollHintLabel}
        />
        <Day0GetStartedSection
          sectionRef={(el) => (sectionRefs.current[2] = el)}
        />
      </div>
    </>
  );
}
